module.exports = __webpack_public_path__ + "static/media/mark-1.ea59962e.png";